"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-84386a86"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = {
    key: 0,
    class: "upgrade-message-overlay"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "upgrade-message-card text-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "modal-title h4" }, "アップグレードが必要です"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "この機能を使用するためには"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "pro-label pto-label m-2" }),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "プランへアップグレードが必要です")
], -1 /* HOISTED */));
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = { class: "settings-card-container" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-title-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createCommentVNode)(" <CSVIcon class=\"page-title-text\"/> "),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "有休管理")
], -1 /* HOISTED */));
const _hoisted_6 = { class: "settings-item" };
const _hoisted_7 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "有休取得日", -1 /* HOISTED */));
const _hoisted_9 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "空の場合は入社日のみを使用 ")
], -1 /* HOISTED */));
const _hoisted_11 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_12 = { class: "d-flex flex-gap flex-wrap settings-input" };
const _hoisted_13 = { class: "settings-item pto-config-table-wrapper" };
const _hoisted_14 = {
    key: 1,
    class: "settings-submit-button-wrapper"
};
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-undo" }, null, -1 /* HOISTED */));
const _hoisted_16 = [
    _hoisted_15
];
const vue_3 = require("vue");
const PtoConfigTable_vue_1 = __importDefault(require("./PtoConfigTable.vue"));
const InfoIcon_vue_1 = __importDefault(require("../../vue/icons/InfoIcon.vue"));
const ptoConfigParser_1 = require("../parser/ptoConfigParser");
const GrantDay_vue_1 = __importDefault(require("./GrantDay.vue"));
const ptoConfigRequest_1 = require("../../requests/ptoConfigRequest");
const settings_1 = require("../../js/settings");
exports.default = (0, vue_1.defineComponent)({
    __name: 'PtoConfig',
    props: {
        ptoConfigProp: {
            type: Object,
            required: true,
        },
        meStore: {
            type: Object,
            required: true,
        },
        permissions: {
            type: Object,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        const isLoading = (0, vue_3.ref)(false);
        const parsedPtoConfig = props.ptoConfigProp;
        const ptoConfig = (0, vue_3.reactive)(parsedPtoConfig);
        const ptoGrantMonth = (0, vue_3.ref)(undefined);
        const ptoGrantDate = (0, vue_3.ref)(undefined);
        // Save current config
        const oneDayCurrentConfig = ptoConfig.getOneDayConfig().getConfigDays();
        const twoDayCurrentConfig = ptoConfig.getTwoDaysConfig().getConfigDays();
        const threeDayCurrentConfig = ptoConfig.getThreeDaysConfig().getConfigDays();
        const fourDayCurrentConfig = ptoConfig.getFourDaysConfig().getConfigDays();
        const fiveDayCurrentConfig = ptoConfig.getFiveDaysConfig().getConfigDays();
        const canUse = (0, vue_3.computed)(() => {
            return (props.permissions.hasPtoPerm || props.permissions.hasTrialPerm) ?? false;
        });
        const loadingClass = (0, vue_3.computed)(() => {
            return {
                "loading": isLoading.value
            };
        });
        const disabledPage = (0, vue_3.computed)(() => {
            return {
                'disabled-page': !canUse.value,
            };
        });
        const ptoGrantDay = (0, vue_3.computed)(() => {
            return ptoConfig.getGrantDay();
        });
        const ptoConfigDays = (0, vue_3.computed)(() => {
            return ptoConfig.getConfigDays();
        });
        function setCurrentConfig() {
            ptoConfig.reset();
            ptoConfig.getOneDayConfig().setConfigDays(oneDayCurrentConfig);
            ptoConfig.getTwoDaysConfig().setConfigDays(twoDayCurrentConfig);
            ptoConfig.getThreeDaysConfig().setConfigDays(threeDayCurrentConfig);
            ptoConfig.getFourDaysConfig().setConfigDays(fourDayCurrentConfig);
            ptoConfig.getFiveDaysConfig().setConfigDays(fiveDayCurrentConfig);
        }
        function setDefault() {
            ptoConfig.setDefault();
        }
        function setGrantDayRef() {
            let n;
            if (ptoGrantDay.value) {
                n = ptoGrantDay.value?.getMonth() + 1;
            }
            ptoGrantMonth.value = n;
            ptoGrantDate.value = ptoGrantDay.value?.getDate();
        }
        function handleGrantDayMonth(month) {
            if (isNaN(month)) {
                month = 0;
            }
            ptoGrantMonth.value = month;
        }
        function handleGrantDayDate(date) {
            if (isNaN(date)) {
                date = 0;
            }
            ptoGrantDate.value = date;
        }
        function handleEmitPtoConfig(config) {
            const { halfYear, oneAndHalfYear, twoAndHalfYears, threeAndHalfYears, fourAndHalfYears, fiveAndHalfYears, sixAndHalfYears, numIndicator, } = config.value;
            const ptoConfigDay = ptoConfig.getConfigDaysByInt(numIndicator);
            ptoConfigDay.setConfigDays({
                halfYear,
                oneAndHalfYear,
                twoAndHalfYears,
                threeAndHalfYears,
                fourAndHalfYears,
                fiveAndHalfYears,
                sixAndHalfYears,
            });
        }
        function parseGrantDayForSubmit() {
            let date;
            if (ptoGrantMonth.value && ptoGrantDate.value) {
                date = new Date();
                date.setMonth(ptoGrantMonth.value - 1);
                date.setDate(ptoGrantDate.value);
            }
            ptoConfig.setGrantDay(date);
        }
        async function handlePTOSubmit() {
            try {
                isLoading.value = true;
                parseGrantDayForSubmit();
                const payload = (0, ptoConfigParser_1.parseToRaw)(ptoConfig);
                const isSuccess = await (0, ptoConfigRequest_1.ptoConfigUpdateHandler)(props.meStore.getActiveUserId(), payload);
                if (isSuccess) {
                    (0, settings_1.importAlertModal)().alertSuccess("設定を更新しました！");
                }
            }
            catch (err) {
                console.error(err);
                (0, settings_1.importAlertModal)().alert(err);
            }
            finally {
                isLoading.value = false;
            }
        }
        (0, vue_3.onMounted)(() => {
            setGrantDayRef();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: (0, vue_2.normalizeClass)(["main-settings-container", disabledPage.value])
            }, [
                (!canUse.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, _hoisted_3))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                    (0, vue_2.createCommentVNode)(" PTO settings "),
                    _hoisted_5,
                    (0, vue_2.createCommentVNode)(" Grant Day "),
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                            _hoisted_8,
                            (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                _hoisted_10
                            ])
                        ]),
                        (!canUse.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_11))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_12, [
                            (0, vue_2.createVNode)(GrantDay_vue_1.default, {
                                "grant-day-month": ptoGrantMonth.value,
                                "grant-day-date": ptoGrantDate.value,
                                onMonth: handleGrantDayMonth,
                                onDay: handleGrantDayDate
                            }, null, 8 /* PROPS */, ["grant-day-month", "grant-day-date"])
                        ])
                    ]),
                    (0, vue_2.createCommentVNode)(" PTO config Table "),
                    (0, vue_2.createElementVNode)("div", _hoisted_13, [
                        (0, vue_2.createVNode)(PtoConfigTable_vue_1.default, {
                            "pto-config-days": ptoConfigDays.value,
                            onConfigParams: handleEmitPtoConfig
                        }, null, 8 /* PROPS */, ["pto-config-days"])
                    ])
                ]),
                (canUse.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, [
                        (0, vue_2.createElementVNode)("button", {
                            class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn", loadingClass.value]),
                            onClick: handlePTOSubmit
                        }, "確定", 2 /* CLASS */),
                        (0, vue_2.createElementVNode)("div", { class: "d-flex flex-gap" }, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "oplus-modal-btn oplus-btn-secondary",
                                onClick: setDefault
                            }, "デフォルト"),
                            (0, vue_2.createElementVNode)("button", {
                                class: "oplus-modal-btn oplus-btn-secondary undo-btn",
                                onClick: setCurrentConfig
                            }, _hoisted_16)
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
